<template>
  <section>
    <el-form inline>
      <el-form-item label="托盘编码">
        <el-input
          v-model="filters.keyword"
          placeholder="请输入托盘编码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-select v-model="filters.enabled" multiple="">
          <el-option label="启用" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库名称">
        <el-select v-model="filters.wareid" multiple="" filterable>
          <el-option
            v-for="item in WareHousebase"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!-- 查询报表 -->
    <el-table-bar :fixed="true" :bottom="35">  
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        highlight-current-row
      
        v-loading="listLoading"
        @selection-change="selsChange"
          ref="multipleTable"
         @row-click="handleRowClick"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="palletCode" label="托盘编码" sortable>
        </el-table-column>
        <el-table-column prop="warehouseCode" label="仓库编码" sortable>
        </el-table-column>
        <el-table-column prop="warehouseName" label="仓库名称" sortable>
        </el-table-column>

        <el-table-column prop="status" label="是否启用" sortable>
          <template slot-scope="scope">{{
            scope.row.status ? "禁用" : "启用"
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="getbusinessLoglist(6, scope.row.palletId)"
              type="text"
              size="small"
              >日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total" style="float:right;"
      >
      </el-pagination>
    </div>

    <!-- 新增模块 -->

    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="托盘编码"
              prop="PalletCode"
              label-width="120px"
            >
              <el-input
                v-model="addForm.PalletCode"
                auto-complete="off"
                placeholder="请输入托盘编码"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仓库名称"
              prop="WarehouseId"
              label-width="120px"
            >
              <el-select v-model="addForm.WarehouseId" filterable style="width: 100%">
                <el-option
                  v-for="item in WareHouse"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="Status" label-width="120px">
              <el-select v-model="addForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改模块 -->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editRuleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="托盘编码"
              prop="PalletCode"
              label-width="120px"
            >
              <el-input
                v-model="editForm.PalletCode"
                auto-complete="off"
                placeholder="请输入托盘编码"
                maxlength="50"
                disabled
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仓库名称"
              label-width="120px"
              prop="WarehouseId"
            >
              <el-select
                v-model="editForm.WarehouseId"
                :disabled="isVisible" filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in editWareHouse"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="是否启用" label-width="120px" prop="Status">
              <el-select v-model="editForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onEditSubmit" :loading="editLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 导入文件 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="导入文件"
      width="40%"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <!-- 上传文件 -->

            <el-upload
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <el-button type="primary" @click="handleDownload()"
              >下载导入模板</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改日志 -->
    <el-dialog
      :visible.sync="logFormVisible"
      v-model="logFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-table
        :data="logtableData"
        height="500"
        border
        style="width: 100%"
        v-loading="loglistLoading"
      >
        <el-table-column prop="createBy" label="操作人" width="120" sortable>
        </el-table-column>
        <el-table-column prop="ip" label="操作人IP地址" width="140" sortable>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="操作时间"
          width="180"
          sortable
          :formatter="formatdatetime"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="操作内容"
          min-width="300"
          sortable
        >
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination
          @size-change="loghandleSizeChange"
          @current-change="loghandleCurrentChange"
          :current-page="logpage"
          :page-sizes="[10, 20, 50,100]"
          :page-size="logpageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="logtotal" style="float:right;"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
import {
  getWarehouseAreabase,
  addWarehousePallet,
  getWarehousePalletList,
  editWarehousePallet,
  editWarehousePalletStatus,
  exportWarehousePallet,
  importWarehousePallet,
  getWarehousePalletQueryById,
  downloadWarehousePalletLabel,
  getbusinessLog,
  getWarehouseByOrg,
  downloadWarehousePallet,
} from "../../api/api";
import axios from "axios";
export default {
  components: { Toolbar },
  data() {
    return {
      dialogVisible: false, //隐藏图片展示框
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      Importtext: "", //导入返回信息
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 50,
      tableData: [],
      filters: {
        keyword: "",
        enabled: "",
        wareid: "",
      },
      WareHousebase: [],
      WareHouse: [],
      buttonList: {},
      addFormVisible: false,
      addLoading: false,
      addForm: {
        PalletCode: "",
        WarehouseId: "",
        Status: "1",
      },
      addFormRules: {
        PalletCode: [
          {
            required: true,
            message: "请输入托盘编码",
            trigger: "blur",
          },
          {
            message: "托盘编码格式不正确,正确格式为字母+数字",
            trigger: "blur",
            pattern: /^((([a-z]|[A-Z])+[0-9]+)|(([A-Z]|[a-z])+[0-9]+))*$/,
          },
        ],
        WarehouseId: [
          { required: true, message: "请选择仓库名称", trigger: "change" },
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      editFormVisible: false,
      editLoading: false,
      editForm: {
        PalletId: 0,
        PalletCode: "",
        WarehouseId: "",
        Status: "1",
      },
      editFormRules: {
        PalletCode: [
          {
            required: true,
            message: "请输入库位编码",
            trigger: "blur",
          },
          {
            message: "库位编码格式不正确",
            trigger: "blur",
            pattern: /^((([a-z]|[A-Z])+[0-9]+)|(([A-Z]|[a-z])+[0-9]+))*$/,
          },
        ],
        WarehouseId: [
          { required: true, message: "请选择仓库名称", trigger: "change" },
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      currentRow: null,
      sels: [],
      validation: true,
      importVisible: false,
      editWareHouse: [], //修改赋值
      isVisible: false,
      logFormVisible: false,
      logtableData: [],
      loglistLoading: false,
      logtotal: 0,
      logpage: 1,
      logpageSize: 50,
      logbusinessType: 0,
      logbusinessCode: 0,
      newfilters:{},
    };
  },
  methods: {
    //加载权限按钮
    callFunction(item) {
      if (item.name === "查询") {
         this.page=1;
         this.newfilters =JSON.parse(JSON.stringify(this.filters)) ;
          this.getReportlist.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //弹出导入文件框
    importExport() {
      this.Importtext = "";
      this.importVisible = true;
    },
    //弹出新增框
    onSubmitadd() {
      this.addFormVisible = true;
      this.addLoading = false;
    },
    //弹出修改框
    onSubmitedit() {
      let row = {};
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length === 1) {
        row = this.sels[0];
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      this.editLoading = false;
      let ware = JSON.stringify(this.WareHouse);
      if (!row || row.warehouseId == 0) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }

      let pata = {
        id: row.palletId,
      };
      this.editWareHouse = [];
      this.editWareHouse = JSON.parse(ware);
      //console.log(this.WareHouse,this.editWareHouse);
      getWarehousePalletQueryById(pata).then((res) => {
        let editdata = res.data.response;
        if (res.data.success) {
          const index = this.editWareHouse.findIndex(
            (item) => item.warehouseId === editdata.warehouseId
          );

          if (index == -1) {
            let warels = {
              warehouseId: row.warehouseId,
              warehouseName: row.warehouseName,
            };
            this.editWareHouse.push(warels);
          }

          this.editForm.PalletId = editdata.palletId;
          this.editForm.PalletCode = editdata.palletCode;
          this.editForm.WarehouseId = editdata.warehouseId;
          this.editForm.Status = editdata.status + "";
          this.isVisible = editdata.isVisible;
          console.log(this.editForm);
          this.editFormVisible = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    //隐藏新增修改框
    onSubmicancel() {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.importVisible = false;
    },
   //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },
    //获取每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getReportlist();
    },
    //获取页码
    handleCurrentChange(val) {
      this.page = val;
      this.getReportlist();
    },
    //多选
    selsChange(sels) {
      this.sels = sels;
      console.log(sels, 1111);
    },
    //新增
    onAddSubmit() {
      let _this = this;
      let para = Object.assign({}, this.addForm);
      console.log(para);

      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            console.log(para);
            this.addLoading = true;

            addWarehousePallet(para).then((res) => {
              this.addLoading = false;
              console.log(res);
              if (res.data.success) {
                this.addFormVisible = false;
                this.$refs["addRuleForm"].resetFields();
                this.getReportlist();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }).catch((err)=>{
            console.log(err);
          });
        }
      });
    },
    //修改
    onEditSubmit() {
      let _this = this;
      let para = Object.assign({}, this.editForm);

      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            this.editLoading = true;

            console.log(para, user);
            editWarehousePallet(para).then((res) => {
              console.log(res);
              this.editLoading = false;
              if (res.data.success) {
                this.editFormVisible = false;
                this.$refs["editRuleForm"].resetFields();
                this.getReportlist();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }).catch((err)=>{
            console.log(err);
          });
        }
      });
    },

    //查询
    getReportlist(item) {
      toString.call(item) === "[object Object]" ? (this.page = 1) : this.page;
      let pata = {
        page: this.page,
        pageSize: this.pageSize,
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
      };
      this.listLoading = true;
      getWarehousePalletList(pata).then((res) => {
        console.log(res);
        this.tableData = res.data.response.pageData;
        this.total = res.data.response.total;
        this.listLoading = false;
      });
    },
    //导出
    handleExport() {
      let row = this.sels;
      let warelist = "";
      row.forEach((item) => {
        warelist += item.palletId + ",";
      });
      let pata = {
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
        warehouseareaid: warelist.slice(0, warelist.length - 1),
      };
        const loading = this.$loading({
          lock: true,
          text: '导出中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });

      exportWarehousePallet(pata);
       loading.close();
    },
    //点击启用按钮
    handleEnable() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error",
        });

        return;
      }

      if (row.length == 1) {
        if (row[0].status == 0) {
          this.validation = false;
          this.$message({
            message: "当前数据为启用状态，无需启用！",
            type: "error",
          });
          return;
        }
      }

      row.forEach((item) => {
        if (item.status == 0) {
          this.validation = false;
          this.$message({
            message: "请选择禁用的数据启用！",
            type: "error",
          });

          return false;
        }
      });

      let para = Object.assign([], row);

      console.log(para);
      if (this.validation) {
        this.$confirm("确认启用吗?", "提示", {}).then(() => {
          for (let i = 0; i < para.length; i++) {
            para[i].Status = 0;
          }
          editWarehousePalletStatus(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getReportlist();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }).catch((err)=>{
            console.log(err);
          });
      }
    },
    //点击禁用按钮
    handleStop() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择启用的数据禁用！",
          type: "error",
        });

        return false;
      }
      if (row.length == 1) {
        if (row[0].status == 1) {
          this.validation = false;
          this.$message({
            message: "当前数据为禁用状态，无需禁用！！",
            type: "error",
          });
          return;
        }
      }
      row.forEach((item) => {
        if (item.status == 1) {
          this.validation = false;
          this.$message({
            message: "请选择启用的数据禁用！",
            type: "error",
          });
          return false;
        }
      });
      if (this.validation) {
        let para = Object.assign([], row);
        this.$confirm("确认禁用吗?", "提示", {}).then(() => {
          for (let i = 0; i < para.length; i++) {
            para[i].Status = 1;
          }
          editWarehousePalletStatus(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getReportlist();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }).catch((err)=>{
            console.log(err);
          });
      }
    },

    //加载基础资料
    getBasicdatalist() {
      getWarehouseAreabase("").then((res) => {
        this.WareHouse = res.data.response.wareHouse;
      });
      // let user = JSON.parse(window.localStorage.user);
      // getWarehouseByOrg({ orgId: user.organizationId }).then((res) => {
      //   this.WareHousebase = res.data.response.wareHouse;
      // });
       let user = JSON.parse(window.localStorage.user);
      this.WareHousebase = user.warehouseList;
    },

    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }
      return extension || extension2;
    },
    //上传文件
    UploadExcel(param) {
      console.log(param, "文件");
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url: importWarehousePallet,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            console.log("导入成功");
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getReportlist();
          } else {
            // this.$message({
            //   message: res.data.msg,
            //   type: "error",
            // });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },
    //下载模板
    handleDownload() {
      let url = downloadWarehousePallet;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    //下载托盘标签
    downloadPallet() {
    

      let row = this.sels;
      let warelist = "";
      row.forEach((item) => {
        warelist += item.palletId + ",";
      });

      let pata = {
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
        warehouseareaid: warelist.slice(0, warelist.length - 1),
      };
      const loading = this.$loading({
          lock: true,
          text: '下载中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
      downloadWarehousePalletLabel(pata).then((res) => {
         loading.close();
        if (res.data.success) { 
            window.open(res.data.response, '_blank')
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //获取每页条数
    loghandleSizeChange(val) {
      this.logpageSize = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //获取页码
    loghandleCurrentChange(val) {
      this.logpage = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //查询
    getbusinessLoglist(businessType, businessCode) {
      this.logbusinessType = businessType;
      this.businessCode = businessCode;
      this.logFormVisible = true;
      let pata = {
        businessType: this.logbusinessType,
        businessCode: this.businessCode,
        page: this.logpage,
        pageSize: this.logpageSize,
      };
      this.loglistLoading = true;
      getbusinessLog(pata).then((res) => {
        console.log(res);
        this.logtableData = res.data.response.pageData;
        this.logtotal = res.data.response.total;
        this.loglistLoading = false;
      });
    },
    formatdatetime: function (row) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.createTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
  },
  mounted() {
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    // console.log(111);
    this.getBasicdatalist();
    
  },
};
</script>